// File: frontend/src/i18n/aiops.js
// Version: 1.0 (2026-10-17)
// Description: словарь экрана AI Operations Hub (EN/RU) и функция перевода.
//
// 🔴 Ни одной фирмы, города, регулятора или ведомства в тексте: экран общий для
//    арендаторов, а факты фирмы живут в её каноне. 17.10.2026 на ELN здесь
//    стояли «Miami Headquarters», «USCIS checklists», «Florida Bar Rule 4-5.3»
//    и «иммиграционный консилиум» — и ~170 русских строк в английской версии.

const EN = {
    'aiops.header.kicker': 'One command layer for every AI capability',
    'aiops.header.title': 'AI Operations Hub',
    'aiops.header.subtitle': 'Use one team view instead of separate AI dashboards. Katifi keeps every agent in the same client and case context.',
    'aiops.header.ask_katifi': 'Ask Katifi for priorities',
    'aiops.header.ask_katifi_prompt': 'Summarize what the AI team needs me to decide today',

    'aiops.metric.decision': 'Needs your decision',
    'aiops.metric.decision_in_review': 'in review',
    'aiops.metric.decision_no_answer': 'counter did not respond',
    'aiops.metric.roster': 'AI Swarm Roster',
    'aiops.metric.roster_loading': 'querying registry',
    'aiops.metric.roster_error': 'agent registry did not respond',
    'aiops.metric.roster_empty': 'registry is empty',
    'aiops.metric.roster_operational': '{n} operational',
    'aiops.metric.cases': 'Active Cases',
    'aiops.metric.cases_clients': 'Across {n} clients',
    'aiops.metric.cases_no_clients': 'client count not received',

    'aiops.tab.team': 'AI Team',
    'aiops.tab.voice': 'Voice AI',
    'aiops.tab.paralegal': 'Paralegal',
    'aiops.tab.council': 'Council',

    'aiops.team.builtin_notice': 'The agent registry is empty, so these are the built-in roles of the system. Status, score and location are not measured for them.',
    'aiops.team.builtin_notice_error': 'The agent registry did not respond, so these are the built-in roles of the system. Status, score and location are not measured for them.',
    'aiops.team.status_active': 'Active',
    'aiops.team.status_standby': 'Standby',
    'aiops.team.role_default': 'Legal AI Specialist',
    'aiops.team.detail_default': 'AI agent assisting the legal practice.',
    'aiops.team.verified': 'Verified agent',
    'aiops.agent.katifi.role': 'Command center',
    'aiops.agent.katifi.detail': 'Monitors active cases, deadlines and incoming requests across the firm.',
    'aiops.agent.sofia.role': 'Front desk & calls',
    'aiops.agent.sofia.detail': 'Answers calls, captures intake facts and schedules consultations.',
    'aiops.agent.paralegal.name': 'Paralegal AI',
    'aiops.agent.paralegal.role': 'Documents & checklists',
    'aiops.agent.paralegal.detail': 'Checks documents against the matter checklist, identifies gaps and prepares drafts for attorney review.',
    'aiops.agent.council.role': 'Risk & legal strategy',
    'aiops.agent.council.detail': 'Surfaces disagreements between team roles and prepares decision-ready memos for the attorney.',

    'aiops.voice.title': 'Sofia Voice — call log',
    'aiops.voice.languages': 'Languages: English, Russian, Spanish. Recordings and transcripts come from the call log.',
    'aiops.voice.recent': 'Recent recordings',
    'aiops.voice.count': '{n} in log',
    'aiops.voice.loading': 'Loading…',
    'aiops.voice.error': 'Could not load the call log: {error}',
    'aiops.voice.empty': 'No call recordings yet',
    'aiops.voice.no_outcome': 'no outcome',
    'aiops.voice.open_history': 'Open complete history →',
    'aiops.voice.signs': 'Call signals:',
    'aiops.voice.sign_intent': 'intent — {v}',
    'aiops.voice.sign_sentiment': 'tone — {v}',
    'aiops.voice.sign_ended': 'ended — {v}',
    'aiops.voice.signs_none': 'the call log named none',
    'aiops.voice.pause': 'Pause',
    'aiops.voice.play': 'Play recording',
    'aiops.voice.unmute': 'Unmute',
    'aiops.voice.mute': 'Mute',
    'aiops.voice.progress': 'Recording progress',
    'aiops.voice.seek': 'Seek to {n} seconds',
    'aiops.voice.no_audio': 'This call has no audio recording',
    'aiops.voice.transcript': 'Transcript',
    'aiops.voice.transcript_hint': 'Select the lines to include in the note draft',
    'aiops.voice.generate': 'Generate notes',
    'aiops.voice.no_transcript': 'This call has no transcript',
    'aiops.voice.select_line': 'Select line #{n}',
    'aiops.voice.speaker_sofia': 'Sofia (AI)',
    'aiops.voice.speaker_caller': 'Caller',
    'aiops.voice.review_inbox': 'Review all calls in Omnichannel Inbox',

    'aiops.note.toast': 'Draft composed in the browser. It is NOT saved to the client history.',
    'aiops.note.title': 'Attorney note draft',
    'aiops.note.not_saved': 'Browser draft · NOT saved to history',
    'aiops.note.call': 'Call',
    'aiops.note.lines': 'Selected lines',
    'aiops.note.open_history': 'Open history',
    'aiops.note.open_katifi': 'Open in Katifi for refinement →',
    'aiops.note.katifi_prompt': 'Review the lines of call {call} ({when}): {lines}',
    'aiops.katifi.toast': 'Katifi: "{prompt}" is being processed in the practice context…',

    'aiops.paralegal.title': 'The paralegal queue is not connected to a source',
    'aiops.paralegal.body': 'There is no endpoint yet that returns document review tasks. An empty space here is more honest than a plausible list: "no work" and "nothing to ask" are different things. See the matters in the Cases section.',
    'aiops.open_cases': 'Open cases',

    'aiops.council.case_context': 'Active case context:',
    'aiops.council.case_n': 'Case #{n}',
    'aiops.council.case_default_title': 'Case',
    'aiops.council.back_to_case': '← Back to case',
    'aiops.council.memo': 'Decision-ready memo',
    'aiops.council.no_case': 'No case selected',
    'aiops.council.case_not_held': 'No council has been held for this case: the system has no decision storage yet, so there is nothing to show. Run it manually from the case.',
    'aiops.council.open_from_case': 'Open the council from a case card so the review has a subject. Without a case there is nothing to show, and the screen will not invent anything.',
    'aiops.council.what_is': 'What is the council',
    'aiops.council.modal_kicker': 'AI Council',
    'aiops.council.modal_title': 'The concept, not the state of affairs',
    'aiops.council.modal_what': 'What it is:',
    'aiops.council.modal_what_body': 'a review in which the practice roles (risk advisor, paralegal, Katifi) give separate views on one case, and the disagreement between them is brought to the attorney as a decision that a person must make.',
    'aiops.council.modal_missing': 'What is NOT here:',
    'aiops.council.modal_missing_body': 'storage for council decisions and an endpoint that returns them. Until they exist, the screen will not show any review — neither a real one nor a plausible one.',
    'aiops.close': 'Close',

    'aiops.signals.title': 'Live operating signals',
    'aiops.signals.katifi': 'Katifi',
    'aiops.signals.katifi_registry': 'Agent registry: {n} agents',
    'aiops.signals.katifi_registry_empty': 'Agent registry is empty',
    'aiops.signals.katifi_registry_error': 'Agent registry did not respond',
    'aiops.signals.sofia': 'Sofia Voice',
    'aiops.signals.sofia_calls': '{n} calls in the log',
    'aiops.signals.paralegal': 'Paralegal AI',
    'aiops.signals.paralegal_queue': 'Queue not connected to a source',

    'aiops.deadlines.title': 'The system does not track deadlines',
    'aiops.deadlines.body': 'There is no deadline tracking for cases in the system yet, so there is nothing to show here. Check deadlines in the cases themselves.',
    'aiops.deadlines.open': 'Open cases →',

    'aiops.guard.title': 'AI language & guardrails',
    'aiops.guard.subtitle': 'Voice languages, greeting scripts, roles and attorney approval rules.',
    'aiops.guard.modal_subtitle': 'Attorney supervision of AI assistance',
    'aiops.guard.languages': 'Sofia Voice languages',
    'aiops.guard.lang_en': 'English',
    'aiops.guard.lang_ru': 'Russian',
    'aiops.guard.lang_es': 'Spanish',
    'aiops.guard.upl': 'No legal advice without an attorney',
    'aiops.guard.upl_body': 'Sofia and the paralegal AI only collect facts. No legal opinions, engagement agreements or outcome assessments go to a client without direct authorization by a licensed attorney (human-in-the-loop).',
    'aiops.guard.trail': 'Records:',
    'aiops.guard.trail_body': 'call recordings and transcripts are kept in the call log. Note drafts on this screen are not saved.',
};

const RU = {
    'aiops.header.kicker': 'Единый командный слой для всех AI-возможностей',
    'aiops.header.title': 'Центр AI-операций',
    'aiops.header.subtitle': 'Одна командная панель вместо разрозненных AI-дашбордов. Katifi держит всех агентов в едином контексте клиента и дела.',
    'aiops.header.ask_katifi': 'Спросить Katifi о приоритетах',
    'aiops.header.ask_katifi_prompt': 'Кратко: что AI-команде нужно от меня решить сегодня',

    'aiops.metric.decision': 'Ждёт вашего решения',
    'aiops.metric.decision_in_review': 'в разборе',
    'aiops.metric.decision_no_answer': 'счётчик не ответил',
    'aiops.metric.roster': 'Состав AI-роя',
    'aiops.metric.roster_loading': 'спрашиваем реестр',
    'aiops.metric.roster_error': 'реестр агентов не ответил',
    'aiops.metric.roster_empty': 'реестр пуст',
    'aiops.metric.roster_operational': 'в работе: {n}',
    'aiops.metric.cases': 'Активные дела',
    'aiops.metric.cases_clients': 'У {n} клиентов',
    'aiops.metric.cases_no_clients': 'число клиентов не получено',

    'aiops.tab.team': 'AI-команда',
    'aiops.tab.voice': 'Голосовой AI',
    'aiops.tab.paralegal': 'Паралигал',
    'aiops.tab.council': 'Консилиум',

    'aiops.team.builtin_notice': 'Реестр агентов пуст, поэтому здесь встроенные роли системы. Статус, баллы и место для них не измеряются.',
    'aiops.team.builtin_notice_error': 'Реестр агентов не ответил, поэтому здесь встроенные роли системы. Статус, баллы и место для них не измеряются.',
    'aiops.team.status_active': 'Активен',
    'aiops.team.status_standby': 'В резерве',
    'aiops.team.role_default': 'Юридический AI-специалист',
    'aiops.team.detail_default': 'AI-агент, помогающий практике.',
    'aiops.team.verified': 'Проверенный агент',
    'aiops.agent.katifi.role': 'Командный центр',
    'aiops.agent.katifi.detail': 'Следит за активными делами, сроками и входящими обращениями по всей фирме.',
    'aiops.agent.sofia.role': 'Приёмная и звонки',
    'aiops.agent.sofia.detail': 'Отвечает на звонки, собирает факты для приёма и записывает на консультации.',
    'aiops.agent.paralegal.name': 'AI-паралигал',
    'aiops.agent.paralegal.role': 'Документы и чек-листы',
    'aiops.agent.paralegal.detail': 'Сверяет документы с чек-листом дела, находит пробелы и готовит черновики на проверку адвокату.',
    'aiops.agent.council.role': 'Риски и правовая стратегия',
    'aiops.agent.council.detail': 'Выявляет расхождения между ролями команды и готовит адвокату записки для решения.',

    'aiops.voice.title': 'Sofia Voice — журнал звонков',
    'aiops.voice.languages': 'Языки: английский, русский, испанский. Записи и расшифровки берутся из журнала звонков.',
    'aiops.voice.recent': 'Последние записи',
    'aiops.voice.count': '{n} в журнале',
    'aiops.voice.loading': 'Загружается…',
    'aiops.voice.error': 'Не удалось получить журнал звонков: {error}',
    'aiops.voice.empty': 'Записей звонков пока нет',
    'aiops.voice.no_outcome': 'без исхода',
    'aiops.voice.open_history': 'Открыть всю историю →',
    'aiops.voice.signs': 'Признаки звонка:',
    'aiops.voice.sign_intent': 'намерение — {v}',
    'aiops.voice.sign_sentiment': 'тон — {v}',
    'aiops.voice.sign_ended': 'завершён — {v}',
    'aiops.voice.signs_none': 'журнал не назвал ни одного',
    'aiops.voice.pause': 'Пауза',
    'aiops.voice.play': 'Слушать запись',
    'aiops.voice.unmute': 'Включить звук',
    'aiops.voice.mute': 'Выключить звук',
    'aiops.voice.progress': 'Ход записи',
    'aiops.voice.seek': 'Перейти к {n} с',
    'aiops.voice.no_audio': 'Аудиозаписи у этого звонка нет',
    'aiops.voice.transcript': 'Расшифровка',
    'aiops.voice.transcript_hint': 'Отметьте реплики, которые войдут в черновик заметки',
    'aiops.voice.generate': 'Составить заметку',
    'aiops.voice.no_transcript': 'Расшифровки у этого звонка нет',
    'aiops.voice.select_line': 'Выбрать реплику №{n}',
    'aiops.voice.speaker_sofia': 'Sofia (AI)',
    'aiops.voice.speaker_caller': 'Звонивший',
    'aiops.voice.review_inbox': 'Все звонки во входящих',

    'aiops.note.toast': 'Черновик составлен в браузере. В историю клиента он НЕ сохранён.',
    'aiops.note.title': 'Черновик заметки адвоката',
    'aiops.note.not_saved': 'Черновик в браузере · в историю НЕ сохранён',
    'aiops.note.call': 'Звонок',
    'aiops.note.lines': 'Выбранные реплики',
    'aiops.note.open_history': 'Открыть историю',
    'aiops.note.open_katifi': 'Доработать в Katifi →',
    'aiops.note.katifi_prompt': 'Разбери реплики звонка {call} ({when}): {lines}',
    'aiops.katifi.toast': 'Katifi: «{prompt}» обрабатывается в контексте практики…',

    'aiops.paralegal.title': 'Очередь паралигала к источнику не подключена',
    'aiops.paralegal.body': 'Ручки, которая отдаёт задачи проверки документов, в системе пока нет. Пустое место здесь честнее правдоподобного списка: «работы нет» и «спросить некого» — разные вещи. Дела смотрите в разделе дел.',
    'aiops.open_cases': 'Открыть дела',

    'aiops.council.case_context': 'Активный контекст дела:',
    'aiops.council.case_n': 'Дело №{n}',
    'aiops.council.case_default_title': 'Дело',
    'aiops.council.back_to_case': '← Вернуться в дело',
    'aiops.council.memo': 'Записка для решения',
    'aiops.council.no_case': 'Дело не выбрано',
    'aiops.council.case_not_held': 'Консилиум по этому делу ещё не собирался: хранилища решений в системе нет, и показать здесь нечего. Соберите его вручную из дела.',
    'aiops.council.open_from_case': 'Откройте консилиум из карточки дела — тогда у разбора будет предмет. Без дела экран показывать нечего, и выдумывать он не будет.',
    'aiops.council.what_is': 'Что такое консилиум',
    'aiops.council.modal_kicker': 'AI-консилиум',
    'aiops.council.modal_title': 'Замысел, а не состояние дел',
    'aiops.council.modal_what': 'Что это:',
    'aiops.council.modal_what_body': 'разбор, в котором роли практики (риск-советник, паралигал, Katifi) высказываются по одному делу порознь, а расхождение между ними выносится адвокату как решение, которое обязан принять человек.',
    'aiops.council.modal_missing': 'Чего здесь НЕТ:',
    'aiops.council.modal_missing_body': 'хранилища решений консилиума и ручки, которая их отдаёт. Пока их не будет, экран не покажет ни одного разбора — ни настоящего, ни правдоподобного.',
    'aiops.close': 'Закрыть',

    'aiops.signals.title': 'Живые сигналы',
    'aiops.signals.katifi': 'Katifi',
    'aiops.signals.katifi_registry': 'Реестр агентов: {n}',
    'aiops.signals.katifi_registry_empty': 'Реестр агентов пуст',
    'aiops.signals.katifi_registry_error': 'Реестр агентов не ответил',
    'aiops.signals.sofia': 'Sofia Voice',
    'aiops.signals.sofia_calls': 'Звонков в журнале: {n}',
    'aiops.signals.paralegal': 'AI-паралигал',
    'aiops.signals.paralegal_queue': 'Очередь к источнику не подключена',

    'aiops.deadlines.title': 'Сроков система не считает',
    'aiops.deadlines.body': 'Учёта сроков по делам в системе пока нет — и показывать здесь нечего. Сроки смотрите в самих делах.',
    'aiops.deadlines.open': 'Открыть дела →',

    'aiops.guard.title': 'Языки AI и рамки',
    'aiops.guard.subtitle': 'Языки голоса, сценарии приветствия, роли и правила одобрения адвокатом.',
    'aiops.guard.modal_subtitle': 'Надзор адвоката за работой AI',
    'aiops.guard.languages': 'Языки Sofia Voice',
    'aiops.guard.lang_en': 'Английский',
    'aiops.guard.lang_ru': 'Русский',
    'aiops.guard.lang_es': 'Испанский',
    'aiops.guard.upl': 'Без правовых советов без адвоката',
    'aiops.guard.upl_body': 'Sofia и AI-паралигал только собирают факты. Никакие правовые заключения, соглашения о представительстве или оценки исхода не выдаются клиенту без прямой авторизации лицензированным адвокатом (human-in-the-loop).',
    'aiops.guard.trail': 'Записи:',
    'aiops.guard.trail_body': 'записи и расшифровки звонков хранятся в журнале звонков. Черновики заметок на этом экране не сохраняются.',
};

export const SLOVAR = Object.freeze({ en: Object.freeze(EN), ru: Object.freeze(RU) });

export function perevesti(lang, key, vars) {
    const slovar = SLOVAR[lang];
    if (!slovar || !Object.prototype.hasOwnProperty.call(slovar, key)) return `[${key}]`;
    const shablon = slovar[key];
    if (!vars || typeof vars !== 'object') return shablon;
    return shablon.replace(/\{([a-zA-Z]+)\}/g, (celoe, imya) => (
        Object.prototype.hasOwnProperty.call(vars, imya) && vars[imya] !== undefined && vars[imya] !== null
            ? String(vars[imya])
            : celoe
    ));
}

export function raznitsaKlyuchey(a, b) {
    const vB = b || {};
    return Object.keys(a || {})
        .filter((k) => !Object.prototype.hasOwnProperty.call(vB, k))
        .sort();
}
